<template>
  <div class="window-height">
    <q-inner-loading showing color="secondary" />
  </div>
</template>

<script lang="ts">
import { LocalStorage } from 'quasar'

export default {
  mounted() {
    const loginRedirectTo = LocalStorage.getItem<string>('loginRedirectTo')
    LocalStorage.removeItem('loginRedirectTo')
    this.$router.push(loginRedirectTo ?? '/')
  }
}
</script>
